import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  "xml:space": "preserve"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M5.39 9.53h19.23v12.21H5.39z" }, null, -1),
    _createElementVNode("path", { d: "M27.14 23.05c.02-.12.03-14.49.03-14.49 0-1.39.04-1.42-1.27-1.42H4.11c-1.3 0-1.26.04-1.26 1.42 0 0 .01 14.37.02 14.49h-1.7v.39c0 1.39 1.33 1.69 2.63 1.69h22.69c1.3 0 2.35-.3 2.35-1.69v-.39h-1.7zm-2.63 1.46h-2.92c-.27 0-.49-.2-.49-.45s.22-.45.49-.45h2.92c.27 0 .49.2.49.45s-.22.45-.49.45zm1.26-1.49h-7.98c0 .58-.36.68-1.09.68h-3.31c-.74 0-1.09-.1-1.09-.68H4.26V8.47h21.51v14.55z" }, null, -1)
  ])))
}
export default { render };